// Centralized translations for 5 languages: English, French, Arabic, Chinese, Spanish.
// Keys are deliberately flat-nested. Used by useT() hook.

import extras from "./extras";

export const LOCALES = [
  { code: "en", label: "English", short: "EN", dir: "ltr" },
  { code: "fr", label: "Français", short: "FR", dir: "ltr" },
  { code: "ar", label: "العربية", short: "AR", dir: "rtl" },
  { code: "zh", label: "中文", short: "ZH", dir: "ltr" },
  { code: "es", label: "Español", short: "ES", dir: "ltr" },
];

const t = {
  en: {
    "nav.home": "Home",
    "nav.about": "About",
    "nav.services": "Services",
    "nav.simp": "SIMP Platform",
    "nav.industries": "Industries",
    "nav.projects": "Track Record",
    "nav.contact": "Contact",
    "nav.cta": "Request a briefing",

    "hero.eyebrow": "Intelligence Logic · Since 1990s",
    "hero.title": "Mission-critical IT systems for governments, enterprises and the African continent.",
    "hero.sub": "Bigradap Group Technologies designs, builds and operates Integrated Multi-Sectoral Permanent Systems — from national elections and civil identity to enterprise content, ICT infrastructure and security.",
    "hero.cta_primary": "Talk to our experts",
    "hero.cta_secondary": "Explore SIMP",
    "hero.stat1": "Years of experience",
    "hero.stat2": "Countries served",
    "hero.stat3": "Sectors covered",
    "hero.stat4": "Continental footprint",

    "section.capabilities.tag": "01 · Capabilities",
    "section.capabilities.title": "A complete enterprise technology stack.",
    "section.capabilities.sub": "End-to-end design, development, supply, implementation and maintenance — backed by partnerships with global technology leaders.",

    "cap.civil.title": "Civil Management & Identification",
    "cap.civil.desc": "Biometric registration, national ID, passports, driving licenses and tachograph cards.",
    "cap.census.title": "Census Management",
    "cap.census.desc": "Population and economic census platforms with secure data acquisition and analytics.",
    "cap.elections.title": "Electoral Systems",
    "cap.elections.desc": "Voter registration, polling logistics, results aggregation and audit-ready transparency.",
    "cap.ecm.title": "Enterprise Content Management",
    "cap.ecm.desc": "Documentum & aXcess implementations for regulated, paper-heavy operations.",
    "cap.ict.title": "ICT Infrastructure",
    "cap.ict.desc": "Data centers, virtualization, IaaS/SaaS, networking, business continuity & disaster recovery.",
    "cap.security.title": "Security Systems",
    "cap.security.desc": "Physical and logical security, surveillance, access control and compliance.",
    "cap.erp.title": "Enterprise Resource Management",
    "cap.erp.desc": "Oracle-based e-business suites tailored to public and private sector workflows.",
    "cap.simp.title": "SIMP — Integrated Multi-Sectoral Permanent System",
    "cap.simp.desc": "Our flagship platform that unifies population, identity and life-event data across ministries.",

    "section.simp.tag": "02 · Flagship Product",
    "section.simp.title": "SIMP — one data backbone for every life event.",
    "section.simp.sub": "From birth to death, marriage to migration, education to employment — SIMP turns fragmented sectoral records into a single, sovereign, auditable source of truth.",
    "simp.bullet1": "Citizen-centric data model · 200+ life events",
    "simp.bullet2": "Multi-tenant for ministries & agencies",
    "simp.bullet3": "Biometric & cryptographic identity",
    "simp.bullet4": "On-prem, hybrid or sovereign cloud",
    "simp.bullet5": "Open API · interoperable with legacy systems",
    "simp.bullet6": "Full audit trail & election-grade transparency",
    "simp.cta": "Request a SIMP demo",

    "section.industries.tag": "03 · Industries",
    "section.industries.title": "Sectors we power.",
    "ind.public": "Public Sector & Government",
    "ind.elections": "Electoral Commissions",
    "ind.telecom": "Telecommunications",
    "ind.banking": "Banking & Insurance",
    "ind.mining": "Mining & Natural Resources",
    "ind.health": "Health Systems",
    "ind.media": "Media & Entertainment",
    "ind.utilities": "Utilities & Regional Government",

    "section.projects.tag": "04 · Track Record",
    "section.projects.title": "30+ years. A continental footprint.",
    "section.projects.sub": "Selected electoral, identity and enterprise programs delivered across Africa.",
    "projects.elections_label": "Electoral programs",
    "projects.docs_label": "Identity documents issued",
    "projects.partners_label": "Technology partners",
    "projects.offices_label": "Offices",

    "section.partners.tag": "05 · Partners",
    "section.partners.title": "Engineered with the world's leading platforms.",

    "section.values.tag": "06 · Values",
    "section.values.title": "Why clients choose Bigradap.",
    "val.quality.title": "Quality",
    "val.quality.desc": "ISO-grade processes. Every deliverable is engineered, reviewed and tested.",
    "val.transparency.title": "Transparency",
    "val.transparency.desc": "Audit-ready architectures. Open documentation. Clear accountability.",
    "val.reliability.title": "Reliability",
    "val.reliability.desc": "Systems that survive elections, audits and 24/7 mission-critical loads.",
    "val.speed.title": "Speed",
    "val.speed.desc": "Continental delivery teams. Built for fast, secure rollouts.",
    "val.security.title": "Security",
    "val.security.desc": "Cryptography, biometrics, segregation of duties, sovereignty by default.",
    "val.collaboration.title": "Collaboration",
    "val.collaboration.desc": "We work side-by-side with ministries, regulators and operators.",

    "cta.footer.title": "Let's build the next national-scale system.",
    "cta.footer.sub": "From the first scoping call to long-term operations — our teams are ready.",
    "cta.footer.btn": "Start a conversation",

    "about.tag": "About",
    "about.title": "Three decades of intelligent IT business solutions.",
    "about.p1": "Bigradap Group Technologies (PTY) LTD is an ICT solutions provider with offices in South Africa and the Democratic Republic of Congo, and active delivery across the African continent.",
    "about.p2": "We design, develop, supply, implement and maintain Integrated Multi-Sectoral Permanent Systems for both public and private sector clients — combining tailor-made software, partner platforms and field operations.",
    "about.p3": "Our mission is to apply an Intelligence Logic approach to every customer challenge: tailor-made IT business solutions that guarantee quality, transparency, reliability, speed and security.",
    "about.mission.label": "Mission",
    "about.mission.body": "We apply an Intelligence Logic approach in our tailor-made customised IT business solutions that guarantees our customers quality, transparency, reliability, speed and security to face business challenges.",
    "about.vision.label": "Vision",
    "about.vision.body": "To use the latest technology to become a world premiere service provider — delivering focused, reliable and intelligent IT business solutions to clients on the African continent and globally.",

    "services.tag": "Services",
    "services.title": "Capabilities, end-to-end.",
    "services.sub": "From feasibility to 24/7 operations — one accountable team.",

    "simp.tag": "Flagship",
    "simp.hero_title": "SIMP — Integrated Multi-Sectoral Permanent System.",
    "simp.hero_sub": "One sovereign data backbone for population, identity and life-event management.",
    "simp.section1.title": "What SIMP does",
    "simp.section1.body": "SIMP unifies records across ministries — civil registration, identity, elections, health, education, taxation and migration — into a single auditable platform. Each life event is captured once and shared, with cryptographic provenance, across all entitled services.",
    "simp.section2.title": "How it's built",
    "simp.section2.body": "Modular micro-services on a hardened core. Biometric capture, secure document personalization, offline-capable field stations, open APIs and a sovereign deployment model — on-prem, hybrid or in-country cloud.",

    "industries.tag": "Industries",
    "industries.title": "Sectors we serve.",
    "industries.sub": "Each program is staffed with sector specialists who speak the language of the regulator.",

    "projects.tag": "Track Record",
    "projects.title": "Selected programs.",
    "projects.sub": "Electoral, identity and enterprise programs delivered across the African continent and beyond.",
    "projects.elections_title": "Electoral footprint",
    "projects.docs_title": "Identity & secure documents",
    "projects.enterprise_title": "Enterprise clients",

    "contact.tag": "Contact",
    "contact.title": "Talk to our teams.",
    "contact.sub": "Tell us about your program. We respond within one business day.",
    "contact.form.name": "Full name",
    "contact.form.email": "Work email",
    "contact.form.company": "Organization",
    "contact.form.country": "Country",
    "contact.form.phone": "Phone (optional)",
    "contact.form.subject": "Subject",
    "contact.form.message": "Tell us about your project",
    "contact.form.submit": "Send message",
    "contact.form.sending": "Sending…",
    "contact.form.success": "Thank you — our team will reply shortly.",
    "contact.form.error": "Something went wrong. Please try again.",
    "contact.offices_title": "Offices",
    "contact.email_title": "Email",
    "contact.phone_title": "Phone",

    "footer.rights": "All rights reserved.",
    "footer.tagline": "Focused, Reliable and Intelligent Business Solutions.",
    "footer.legal": "Legal",
    "footer.privacy": "Privacy",
    "footer.terms": "Terms",
  },
  fr: {
    "nav.home": "Accueil",
    "nav.about": "À propos",
    "nav.services": "Services",
    "nav.simp": "Plateforme SIMP",
    "nav.industries": "Industries",
    "nav.projects": "Références",
    "nav.contact": "Contact",
    "nav.cta": "Demander un briefing",

    "hero.eyebrow": "Intelligence Logic · Depuis les années 1990",
    "hero.title": "Systèmes informatiques critiques pour les États, les entreprises et le continent africain.",
    "hero.sub": "Bigradap Group Technologies conçoit, construit et exploite des Systèmes Intégrés Multi-Sectoriels Permanents — des élections nationales à l'identité civile, en passant par le contenu d'entreprise, l'infrastructure ICT et la sécurité.",
    "hero.cta_primary": "Parler à nos experts",
    "hero.cta_secondary": "Découvrir SIMP",
    "hero.stat1": "Années d'expérience",
    "hero.stat2": "Pays servis",
    "hero.stat3": "Secteurs couverts",
    "hero.stat4": "Présence continentale",

    "section.capabilities.tag": "01 · Capacités",
    "section.capabilities.title": "Une pile technologique d'entreprise complète.",
    "section.capabilities.sub": "Conception, développement, fourniture, mise en œuvre et maintenance de bout en bout — avec les leaders mondiaux de la technologie.",

    "cap.civil.title": "Gestion civile & Identification",
    "cap.civil.desc": "Enregistrement biométrique, carte nationale, passeports, permis de conduire et cartes tachygraphiques.",
    "cap.census.title": "Gestion du recensement",
    "cap.census.desc": "Plateformes de recensement de population et économique avec collecte et analyse sécurisées.",
    "cap.elections.title": "Systèmes électoraux",
    "cap.elections.desc": "Inscription des électeurs, logistique des bureaux de vote, agrégation des résultats et auditabilité.",
    "cap.ecm.title": "Gestion de contenu d'entreprise",
    "cap.ecm.desc": "Mises en œuvre Documentum & aXcess pour les opérations réglementées et documentaires.",
    "cap.ict.title": "Infrastructure ICT",
    "cap.ict.desc": "Centres de données, virtualisation, IaaS/SaaS, réseau, continuité d'activité et reprise.",
    "cap.security.title": "Systèmes de sécurité",
    "cap.security.desc": "Sécurité physique et logique, vidéosurveillance, contrôle d'accès et conformité.",
    "cap.erp.title": "Gestion des ressources d'entreprise",
    "cap.erp.desc": "Suites e-business Oracle adaptées aux flux du public et du privé.",
    "cap.simp.title": "SIMP — Système Intégré Multi-Sectoriel Permanent",
    "cap.simp.desc": "Notre plateforme phare qui unifie les données de population, d'identité et d'événements de vie.",

    "section.simp.tag": "02 · Produit phare",
    "section.simp.title": "SIMP — une seule colonne vertébrale de données pour chaque événement de vie.",
    "section.simp.sub": "De la naissance au décès, du mariage à la migration, de l'éducation à l'emploi — SIMP transforme des registres fragmentés en une source unique, souveraine et auditable.",
    "simp.bullet1": "Modèle de données centré citoyen · 200+ événements de vie",
    "simp.bullet2": "Multi-tenant pour les ministères et agences",
    "simp.bullet3": "Identité biométrique & cryptographique",
    "simp.bullet4": "On-premise, hybride ou cloud souverain",
    "simp.bullet5": "API ouvertes · interopérables avec l'existant",
    "simp.bullet6": "Traçabilité complète & transparence électorale",
    "simp.cta": "Demander une démo SIMP",

    "section.industries.tag": "03 · Industries",
    "section.industries.title": "Les secteurs que nous équipons.",
    "ind.public": "Secteur public & gouvernement",
    "ind.elections": "Commissions électorales",
    "ind.telecom": "Télécommunications",
    "ind.banking": "Banque & assurance",
    "ind.mining": "Mines & ressources naturelles",
    "ind.health": "Systèmes de santé",
    "ind.media": "Médias & divertissement",
    "ind.utilities": "Services publics & gouvernements régionaux",

    "section.projects.tag": "04 · Références",
    "section.projects.title": "Plus de 30 ans. Une empreinte continentale.",
    "section.projects.sub": "Programmes électoraux, d'identité et d'entreprise livrés à travers l'Afrique.",
    "projects.elections_label": "Programmes électoraux",
    "projects.docs_label": "Documents d'identité émis",
    "projects.partners_label": "Partenaires technologiques",
    "projects.offices_label": "Bureaux",

    "section.partners.tag": "05 · Partenaires",
    "section.partners.title": "Conçu avec les plateformes leaders mondiales.",

    "section.values.tag": "06 · Valeurs",
    "section.values.title": "Pourquoi nos clients nous choisissent.",
    "val.quality.title": "Qualité",
    "val.quality.desc": "Processus de niveau ISO. Chaque livrable est conçu, revu et testé.",
    "val.transparency.title": "Transparence",
    "val.transparency.desc": "Architectures auditables. Documentation ouverte. Responsabilité claire.",
    "val.reliability.title": "Fiabilité",
    "val.reliability.desc": "Des systèmes qui résistent aux élections, aux audits et aux charges 24/7.",
    "val.speed.title": "Rapidité",
    "val.speed.desc": "Équipes continentales prêtes pour des déploiements rapides et sûrs.",
    "val.security.title": "Sécurité",
    "val.security.desc": "Cryptographie, biométrie, séparation des tâches, souveraineté par défaut.",
    "val.collaboration.title": "Collaboration",
    "val.collaboration.desc": "Nous travaillons aux côtés des ministères, régulateurs et opérateurs.",

    "cta.footer.title": "Construisons ensemble le prochain système national.",
    "cta.footer.sub": "Du premier appel de cadrage aux opérations long terme — nos équipes sont prêtes.",
    "cta.footer.btn": "Démarrer une conversation",

    "about.tag": "À propos",
    "about.title": "Trois décennies de solutions IT intelligentes.",
    "about.p1": "Bigradap Group Technologies (PTY) LTD est un fournisseur de solutions ICT, présent en Afrique du Sud et en République Démocratique du Congo, avec des projets actifs sur tout le continent africain.",
    "about.p2": "Nous concevons, développons, fournissons, mettons en œuvre et maintenons des Systèmes Intégrés Multi-Sectoriels Permanents pour les secteurs public et privé.",
    "about.p3": "Notre mission : appliquer l'approche Intelligence Logic à chaque défi client — des solutions IT sur mesure qui garantissent qualité, transparence, fiabilité, rapidité et sécurité.",
    "about.mission.label": "Mission",
    "about.mission.body": "Nous appliquons l'approche Intelligence Logic dans nos solutions IT sur mesure, garantissant à nos clients qualité, transparence, fiabilité, rapidité et sécurité.",
    "about.vision.label": "Vision",
    "about.vision.body": "Utiliser les dernières technologies pour devenir un prestataire de services de premier plan mondial — au service du continent africain et au-delà.",

    "services.tag": "Services",
    "services.title": "Capacités, de bout en bout.",
    "services.sub": "De la faisabilité aux opérations 24/7 — une seule équipe responsable.",

    "simp.tag": "Phare",
    "simp.hero_title": "SIMP — Système Intégré Multi-Sectoriel Permanent.",
    "simp.hero_sub": "Une colonne vertébrale de données souveraine pour la population, l'identité et les événements de vie.",
    "simp.section1.title": "Ce que fait SIMP",
    "simp.section1.body": "SIMP unifie les registres entre ministères — état civil, identité, élections, santé, éducation, fiscalité et migration — en une plateforme unique auditable. Chaque événement de vie est capturé une seule fois et partagé avec provenance cryptographique.",
    "simp.section2.title": "Comment c'est construit",
    "simp.section2.body": "Micro-services modulaires sur un cœur durci. Capture biométrique, personnalisation sécurisée des documents, stations terrain offline, API ouvertes, déploiement souverain — on-premise, hybride ou cloud local.",

    "industries.tag": "Industries",
    "industries.title": "Les secteurs que nous servons.",
    "industries.sub": "Chaque programme est porté par des spécialistes sectoriels qui parlent la langue du régulateur.",

    "projects.tag": "Références",
    "projects.title": "Programmes sélectionnés.",
    "projects.sub": "Programmes électoraux, d'identité et d'entreprise livrés à travers l'Afrique et au-delà.",
    "projects.elections_title": "Empreinte électorale",
    "projects.docs_title": "Identité & documents sécurisés",
    "projects.enterprise_title": "Clients entreprises",

    "contact.tag": "Contact",
    "contact.title": "Parlez à nos équipes.",
    "contact.sub": "Parlez-nous de votre programme. Nous répondons sous un jour ouvré.",
    "contact.form.name": "Nom complet",
    "contact.form.email": "Email professionnel",
    "contact.form.company": "Organisation",
    "contact.form.country": "Pays",
    "contact.form.phone": "Téléphone (optionnel)",
    "contact.form.subject": "Objet",
    "contact.form.message": "Parlez-nous de votre projet",
    "contact.form.submit": "Envoyer le message",
    "contact.form.sending": "Envoi…",
    "contact.form.success": "Merci — notre équipe vous répondra rapidement.",
    "contact.form.error": "Une erreur est survenue. Merci de réessayer.",
    "contact.offices_title": "Bureaux",
    "contact.email_title": "Email",
    "contact.phone_title": "Téléphone",

    "footer.rights": "Tous droits réservés.",
    "footer.tagline": "Focused, Reliable and Intelligent Business Solutions.",
    "footer.legal": "Mentions légales",
    "footer.privacy": "Confidentialité",
    "footer.terms": "Conditions",
  },
  ar: {
    "nav.home": "الرئيسية",
    "nav.about": "من نحن",
    "nav.services": "الخدمات",
    "nav.simp": "منصة SIMP",
    "nav.industries": "القطاعات",
    "nav.projects": "السجل",
    "nav.contact": "اتصل بنا",
    "nav.cta": "اطلب جلسة عمل",

    "hero.eyebrow": "Intelligence Logic · منذ التسعينيات",
    "hero.title": "أنظمة معلومات حيوية للحكومات والمؤسسات والقارة الأفريقية.",
    "hero.sub": "تقوم Bigradap Group Technologies بتصميم وبناء وتشغيل أنظمة متكاملة متعددة القطاعات — من الانتخابات الوطنية والهوية المدنية إلى محتوى المؤسسات والبنية التحتية للمعلومات والاتصالات والأمن.",
    "hero.cta_primary": "تحدث إلى خبرائنا",
    "hero.cta_secondary": "اكتشف SIMP",
    "hero.stat1": "سنوات الخبرة",
    "hero.stat2": "الدول المخدومة",
    "hero.stat3": "القطاعات المغطاة",
    "hero.stat4": "حضور قاري",

    "section.capabilities.tag": "01 · القدرات",
    "section.capabilities.title": "حزمة تقنية مؤسسية كاملة.",
    "section.capabilities.sub": "تصميم وتطوير وتوريد وتنفيذ وصيانة شاملة — بالشراكة مع كبار قادة التقنية في العالم.",

    "cap.civil.title": "الإدارة المدنية والتعريف",
    "cap.civil.desc": "تسجيل بيومتري، بطاقة وطنية، جوازات سفر، رخص قيادة وبطاقات تاكوغراف.",
    "cap.census.title": "إدارة التعداد",
    "cap.census.desc": "منصات تعداد السكان والاقتصاد مع جمع وتحليل آمن للبيانات.",
    "cap.elections.title": "الأنظمة الانتخابية",
    "cap.elections.desc": "تسجيل الناخبين، لوجستيات الاقتراع، تجميع النتائج وشفافية التدقيق.",
    "cap.ecm.title": "إدارة محتوى المؤسسات",
    "cap.ecm.desc": "تطبيقات Documentum و aXcess للعمليات المنظمة كثيفة الوثائق.",
    "cap.ict.title": "البنية التحتية للمعلومات والاتصالات",
    "cap.ict.desc": "مراكز بيانات، حوسبة افتراضية، IaaS/SaaS، الشبكات، استمرارية الأعمال والتعافي.",
    "cap.security.title": "أنظمة الأمن",
    "cap.security.desc": "الأمن المادي والمنطقي، المراقبة، التحكم في الوصول والامتثال.",
    "cap.erp.title": "إدارة موارد المؤسسات",
    "cap.erp.desc": "مجموعات Oracle e-business مصممة لمسارات العمل العامة والخاصة.",
    "cap.simp.title": "SIMP — نظام دائم متكامل متعدد القطاعات",
    "cap.simp.desc": "منصتنا الرائدة التي توحد بيانات السكان والهوية وأحداث الحياة عبر الوزارات.",

    "section.simp.tag": "02 · المنتج الرائد",
    "section.simp.title": "SIMP — عمود فقري واحد للبيانات لكل حدث حياة.",
    "section.simp.sub": "من الميلاد إلى الوفاة، ومن الزواج إلى الهجرة — يحول SIMP السجلات المجزأة إلى مصدر واحد سيادي قابل للتدقيق.",
    "simp.bullet1": "نموذج بيانات يتمحور حول المواطن · أكثر من 200 حدث حياة",
    "simp.bullet2": "متعدد المستأجرين للوزارات والوكالات",
    "simp.bullet3": "هوية بيومترية وتشفيرية",
    "simp.bullet4": "محلي، هجين أو سحابة سيادية",
    "simp.bullet5": "واجهات API مفتوحة · قابلة للتشغيل البيني مع الأنظمة القديمة",
    "simp.bullet6": "تتبع كامل وشفافية على مستوى الانتخابات",
    "simp.cta": "اطلب عرض SIMP",

    "section.industries.tag": "03 · القطاعات",
    "section.industries.title": "القطاعات التي نخدمها.",
    "ind.public": "القطاع العام والحكومة",
    "ind.elections": "اللجان الانتخابية",
    "ind.telecom": "الاتصالات",
    "ind.banking": "البنوك والتأمين",
    "ind.mining": "التعدين والموارد الطبيعية",
    "ind.health": "أنظمة الصحة",
    "ind.media": "الإعلام والترفيه",
    "ind.utilities": "المرافق والحكومات الإقليمية",

    "section.projects.tag": "04 · السجل",
    "section.projects.title": "أكثر من 30 عاماً. حضور قاري.",
    "section.projects.sub": "برامج انتخابية وهوية ومؤسسات مختارة تم تنفيذها عبر أفريقيا.",
    "projects.elections_label": "برامج انتخابية",
    "projects.docs_label": "وثائق هوية صادرة",
    "projects.partners_label": "شركاء تقنيون",
    "projects.offices_label": "مكاتب",

    "section.partners.tag": "05 · الشركاء",
    "section.partners.title": "مصمم بأبرز المنصات في العالم.",

    "section.values.tag": "06 · القيم",
    "section.values.title": "لماذا يختارنا العملاء.",
    "val.quality.title": "الجودة",
    "val.quality.desc": "عمليات بمعايير ISO. كل ما نُسلِّمه مهندَس ومراجَع ومختبَر.",
    "val.transparency.title": "الشفافية",
    "val.transparency.desc": "هياكل قابلة للتدقيق، توثيق مفتوح، مسؤولية واضحة.",
    "val.reliability.title": "الموثوقية",
    "val.reliability.desc": "أنظمة تصمد أمام الانتخابات والمراجعات وأعباء العمل 24/7.",
    "val.speed.title": "السرعة",
    "val.speed.desc": "فرق تسليم قارية مصممة لإطلاق سريع وآمن.",
    "val.security.title": "الأمن",
    "val.security.desc": "تشفير، بيومتريا، فصل الواجبات، السيادة افتراضياً.",
    "val.collaboration.title": "التعاون",
    "val.collaboration.desc": "نعمل جنباً إلى جنب مع الوزارات والمنظمين والمشغلين.",

    "cta.footer.title": "لنبنِ معاً النظام الوطني التالي.",
    "cta.footer.sub": "من المكالمة الأولى إلى التشغيل طويل الأمد — فرقنا جاهزة.",
    "cta.footer.btn": "ابدأ المحادثة",

    "about.tag": "من نحن",
    "about.title": "ثلاثة عقود من الحلول الذكية لتقنية المعلومات.",
    "about.p1": "Bigradap Group Technologies (PTY) LTD مزود حلول ICT بمكاتب في جنوب أفريقيا وجمهورية الكونغو الديمقراطية، مع تسليم نشط عبر القارة الأفريقية.",
    "about.p2": "نقوم بتصميم وتطوير وتوريد وتنفيذ وصيانة أنظمة دائمة متكاملة متعددة القطاعات للقطاعين العام والخاص.",
    "about.p3": "مهمتنا تطبيق نهج Intelligence Logic على كل تحدٍ للعميل — حلول IT مصممة خصيصاً تضمن الجودة والشفافية والموثوقية والسرعة والأمن.",
    "about.mission.label": "المهمة",
    "about.mission.body": "نطبق نهج Intelligence Logic في حلول IT المصممة خصيصاً، ضامنين للعملاء الجودة والشفافية والموثوقية والسرعة والأمن.",
    "about.vision.label": "الرؤية",
    "about.vision.body": "استخدام أحدث التقنيات لنصبح مزود خدمات رائد عالمياً — لخدمة القارة الأفريقية والعالم.",

    "services.tag": "الخدمات",
    "services.title": "قدرات شاملة من البداية إلى النهاية.",
    "services.sub": "من الجدوى إلى التشغيل 24/7 — فريق واحد مسؤول.",

    "simp.tag": "المنتج الرائد",
    "simp.hero_title": "SIMP — نظام دائم متكامل متعدد القطاعات.",
    "simp.hero_sub": "عمود فقري سيادي للبيانات السكانية وأحداث الحياة.",
    "simp.section1.title": "ماذا يفعل SIMP",
    "simp.section1.body": "يوحد SIMP السجلات بين الوزارات — الأحوال المدنية، الهوية، الانتخابات، الصحة، التعليم، الضرائب والهجرة — في منصة واحدة قابلة للتدقيق. كل حدث حياة يُلتقط مرة واحدة ويُشارك بمنشأ مشفر.",
    "simp.section2.title": "كيف يُبنى",
    "simp.section2.body": "خدمات مصغرة معيارية على نواة محصنة. التقاط بيومتري، تخصيص آمن للوثائق، محطات ميدانية تعمل دون اتصال، API مفتوحة، نموذج نشر سيادي.",

    "industries.tag": "القطاعات",
    "industries.title": "القطاعات التي نخدمها.",
    "industries.sub": "كل برنامج يديره متخصصون يتحدثون لغة المنظم.",

    "projects.tag": "السجل",
    "projects.title": "برامج مختارة.",
    "projects.sub": "برامج انتخابية وهوية ومؤسسات سُلِّمت عبر القارة الأفريقية وما بعدها.",
    "projects.elections_title": "البصمة الانتخابية",
    "projects.docs_title": "الهوية والوثائق الآمنة",
    "projects.enterprise_title": "عملاء المؤسسات",

    "contact.tag": "اتصل بنا",
    "contact.title": "تحدث إلى فرقنا.",
    "contact.sub": "أخبرنا عن برنامجك. نرد خلال يوم عمل واحد.",
    "contact.form.name": "الاسم الكامل",
    "contact.form.email": "البريد الإلكتروني المهني",
    "contact.form.company": "المؤسسة",
    "contact.form.country": "الدولة",
    "contact.form.phone": "الهاتف (اختياري)",
    "contact.form.subject": "الموضوع",
    "contact.form.message": "أخبرنا عن مشروعك",
    "contact.form.submit": "إرسال الرسالة",
    "contact.form.sending": "جاري الإرسال…",
    "contact.form.success": "شكراً — سيرد فريقنا قريباً.",
    "contact.form.error": "حدث خطأ ما. يرجى المحاولة مرة أخرى.",
    "contact.offices_title": "المكاتب",
    "contact.email_title": "البريد",
    "contact.phone_title": "الهاتف",

    "footer.rights": "جميع الحقوق محفوظة.",
    "footer.tagline": "Focused, Reliable and Intelligent Business Solutions.",
    "footer.legal": "قانوني",
    "footer.privacy": "الخصوصية",
    "footer.terms": "الشروط",
  },
  zh: {
    "nav.home": "首页",
    "nav.about": "关于我们",
    "nav.services": "服务",
    "nav.simp": "SIMP 平台",
    "nav.industries": "行业",
    "nav.projects": "业绩",
    "nav.contact": "联系我们",
    "nav.cta": "预约简报",

    "hero.eyebrow": "Intelligence Logic · 始于 1990 年代",
    "hero.title": "为政府、企业与非洲大陆提供关键任务级 IT 系统。",
    "hero.sub": "Bigradap Group Technologies 设计、构建并运营多部门综合永久系统——从全国选举与公民身份,到企业内容、ICT 基础设施与安全。",
    "hero.cta_primary": "联系专家",
    "hero.cta_secondary": "了解 SIMP",
    "hero.stat1": "经验年数",
    "hero.stat2": "服务国家",
    "hero.stat3": "覆盖行业",
    "hero.stat4": "大陆覆盖",

    "section.capabilities.tag": "01 · 能力",
    "section.capabilities.title": "完整的企业级技术栈。",
    "section.capabilities.sub": "端到端的设计、开发、供应、实施与维护——与全球技术领导者合作。",

    "cap.civil.title": "民事管理与身份识别",
    "cap.civil.desc": "生物识别登记、国民身份证、护照、驾照与司机卡。",
    "cap.census.title": "人口普查管理",
    "cap.census.desc": "人口与经济普查平台,安全采集与分析。",
    "cap.elections.title": "选举系统",
    "cap.elections.desc": "选民登记、投票物流、结果汇总与可审计透明度。",
    "cap.ecm.title": "企业内容管理",
    "cap.ecm.desc": "面向重监管行业的 Documentum 与 aXcess 实施。",
    "cap.ict.title": "ICT 基础设施",
    "cap.ict.desc": "数据中心、虚拟化、IaaS/SaaS、网络、业务连续性与灾备。",
    "cap.security.title": "安全系统",
    "cap.security.desc": "物理与逻辑安全、视频监控、访问控制与合规。",
    "cap.erp.title": "企业资源管理",
    "cap.erp.desc": "基于 Oracle 的电子商务套件,适配公私部门工作流。",
    "cap.simp.title": "SIMP — 多部门综合永久系统",
    "cap.simp.desc": "我们的旗舰平台,跨部委统一人口、身份与生命事件数据。",

    "section.simp.tag": "02 · 旗舰产品",
    "section.simp.title": "SIMP — 每一次生命事件的统一数据中枢。",
    "section.simp.sub": "从出生到死亡,从婚姻到迁移,从教育到就业——SIMP 将分散的部门记录转变为单一、主权、可审计的事实来源。",
    "simp.bullet1": "以公民为中心的数据模型 · 200+ 生命事件",
    "simp.bullet2": "为部委与机构提供多租户支持",
    "simp.bullet3": "生物识别与加密身份",
    "simp.bullet4": "本地、混合或主权云",
    "simp.bullet5": "开放 API · 与既有系统互操作",
    "simp.bullet6": "完整审计轨迹 · 选举级透明度",
    "simp.cta": "申请 SIMP 演示",

    "section.industries.tag": "03 · 行业",
    "section.industries.title": "我们赋能的行业。",
    "ind.public": "公共部门与政府",
    "ind.elections": "选举委员会",
    "ind.telecom": "电信",
    "ind.banking": "银行与保险",
    "ind.mining": "矿业与自然资源",
    "ind.health": "卫生系统",
    "ind.media": "媒体与娱乐",
    "ind.utilities": "公用事业与地方政府",

    "section.projects.tag": "04 · 业绩",
    "section.projects.title": "超过 30 年。覆盖大陆。",
    "section.projects.sub": "在非洲交付的部分选举、身份与企业项目。",
    "projects.elections_label": "选举项目",
    "projects.docs_label": "已发行身份文件",
    "projects.partners_label": "技术合作伙伴",
    "projects.offices_label": "办公室",

    "section.partners.tag": "05 · 合作伙伴",
    "section.partners.title": "与全球领先平台共同构建。",

    "section.values.tag": "06 · 价值观",
    "section.values.title": "客户选择 Bigradap 的原因。",
    "val.quality.title": "质量",
    "val.quality.desc": "ISO 级流程。每一项交付都经过工程、评审与测试。",
    "val.transparency.title": "透明",
    "val.transparency.desc": "可审计架构。公开文档。清晰问责。",
    "val.reliability.title": "可靠",
    "val.reliability.desc": "经得起选举、审计与 7×24 关键负载的系统。",
    "val.speed.title": "速度",
    "val.speed.desc": "覆盖大陆的交付团队,快速且安全地上线。",
    "val.security.title": "安全",
    "val.security.desc": "密码学、生物识别、职责分离,默认主权。",
    "val.collaboration.title": "协作",
    "val.collaboration.desc": "与部委、监管机构和运营商并肩作战。",

    "cta.footer.title": "一起构建下一个国家级系统。",
    "cta.footer.sub": "从首次范围沟通到长期运营——我们的团队随时待命。",
    "cta.footer.btn": "开始对话",

    "about.tag": "关于我们",
    "about.title": "三十年智能 IT 商业解决方案。",
    "about.p1": "Bigradap Group Technologies (PTY) LTD 是一家 ICT 解决方案提供商,办公室位于南非和刚果民主共和国,业务遍及整个非洲大陆。",
    "about.p2": "我们为公私部门客户设计、开发、供应、实施并维护多部门综合永久系统。",
    "about.p3": "我们的使命是将 Intelligence Logic 方法应用于每一个客户挑战——量身定制的 IT 商业解决方案,保证质量、透明、可靠、速度与安全。",
    "about.mission.label": "使命",
    "about.mission.body": "我们以 Intelligence Logic 方法提供量身定制的 IT 商业解决方案,确保质量、透明、可靠、速度与安全。",
    "about.vision.label": "愿景",
    "about.vision.body": "运用最新技术成为世界一流的服务提供商,为非洲大陆及全球客户提供专注、可靠、智能的 IT 商业解决方案。",

    "services.tag": "服务",
    "services.title": "端到端能力。",
    "services.sub": "从可行性到 7×24 运营——一支负责到底的团队。",

    "simp.tag": "旗舰",
    "simp.hero_title": "SIMP — 多部门综合永久系统。",
    "simp.hero_sub": "面向人口、身份与生命事件管理的主权数据中枢。",
    "simp.section1.title": "SIMP 做什么",
    "simp.section1.body": "SIMP 将各部委的记录——民事、身份、选举、卫生、教育、税务与移民——统一到一个可审计的平台。每个生命事件只采集一次,以加密溯源方式共享给所有授权服务。",
    "simp.section2.title": "如何构建",
    "simp.section2.body": "在加固内核上的模块化微服务。生物识别采集、安全文件个性化、可离线现场工作站、开放 API,以及本地、混合或国内云的主权部署模型。",

    "industries.tag": "行业",
    "industries.title": "我们服务的行业。",
    "industries.sub": "每个项目都由行业专家驱动,讲监管者的语言。",

    "projects.tag": "业绩",
    "projects.title": "精选项目。",
    "projects.sub": "在非洲大陆及更远地区交付的选举、身份与企业项目。",
    "projects.elections_title": "选举足迹",
    "projects.docs_title": "身份与安全文件",
    "projects.enterprise_title": "企业客户",

    "contact.tag": "联系我们",
    "contact.title": "与我们的团队对话。",
    "contact.sub": "告诉我们您的项目。我们将在一个工作日内回复。",
    "contact.form.name": "全名",
    "contact.form.email": "工作邮箱",
    "contact.form.company": "机构",
    "contact.form.country": "国家",
    "contact.form.phone": "电话(选填)",
    "contact.form.subject": "主题",
    "contact.form.message": "请告诉我们您的项目",
    "contact.form.submit": "发送信息",
    "contact.form.sending": "发送中…",
    "contact.form.success": "谢谢——我们的团队将很快回复您。",
    "contact.form.error": "出错了,请重试。",
    "contact.offices_title": "办公室",
    "contact.email_title": "邮箱",
    "contact.phone_title": "电话",

    "footer.rights": "保留所有权利。",
    "footer.tagline": "Focused, Reliable and Intelligent Business Solutions.",
    "footer.legal": "法律",
    "footer.privacy": "隐私",
    "footer.terms": "条款",
  },
  es: {
    "nav.home": "Inicio",
    "nav.about": "Quiénes somos",
    "nav.services": "Servicios",
    "nav.simp": "Plataforma SIMP",
    "nav.industries": "Sectores",
    "nav.projects": "Trayectoria",
    "nav.contact": "Contacto",
    "nav.cta": "Solicitar reunión",

    "hero.eyebrow": "Intelligence Logic · Desde los años 1990",
    "hero.title": "Sistemas TI de misión crítica para gobiernos, empresas y el continente africano.",
    "hero.sub": "Bigradap Group Technologies diseña, construye y opera Sistemas Integrados Multisectoriales Permanentes — desde elecciones nacionales e identidad civil hasta gestión de contenido empresarial, infraestructura TIC y seguridad.",
    "hero.cta_primary": "Hablar con expertos",
    "hero.cta_secondary": "Explorar SIMP",
    "hero.stat1": "Años de experiencia",
    "hero.stat2": "Países atendidos",
    "hero.stat3": "Sectores cubiertos",
    "hero.stat4": "Presencia continental",

    "section.capabilities.tag": "01 · Capacidades",
    "section.capabilities.title": "Una pila tecnológica empresarial completa.",
    "section.capabilities.sub": "Diseño, desarrollo, suministro, implementación y mantenimiento integrales — junto a líderes tecnológicos globales.",

    "cap.civil.title": "Gestión civil e identificación",
    "cap.civil.desc": "Registro biométrico, DNI, pasaportes, licencias de conducir y tarjetas de tacógrafo.",
    "cap.census.title": "Gestión de censos",
    "cap.census.desc": "Plataformas de censo poblacional y económico con captura y analítica seguras.",
    "cap.elections.title": "Sistemas electorales",
    "cap.elections.desc": "Registro de votantes, logística electoral, agregación de resultados y transparencia auditable.",
    "cap.ecm.title": "Gestión de contenido empresarial",
    "cap.ecm.desc": "Implementaciones de Documentum y aXcess para operaciones reguladas e intensivas en documentos.",
    "cap.ict.title": "Infraestructura TIC",
    "cap.ict.desc": "Centros de datos, virtualización, IaaS/SaaS, redes, continuidad de negocio y recuperación.",
    "cap.security.title": "Sistemas de seguridad",
    "cap.security.desc": "Seguridad física y lógica, videovigilancia, control de acceso y cumplimiento.",
    "cap.erp.title": "Gestión de recursos empresariales",
    "cap.erp.desc": "Suites e-business basadas en Oracle, adaptadas a flujos del sector público y privado.",
    "cap.simp.title": "SIMP — Sistema Integrado Multisectorial Permanente",
    "cap.simp.desc": "Nuestra plataforma insignia que unifica datos de población, identidad y eventos de vida entre ministerios.",

    "section.simp.tag": "02 · Producto insignia",
    "section.simp.title": "SIMP — una única columna vertebral de datos para cada evento de vida.",
    "section.simp.sub": "Del nacimiento al fallecimiento, del matrimonio a la migración — SIMP convierte registros fragmentados en una única fuente de verdad, soberana y auditable.",
    "simp.bullet1": "Modelo de datos centrado en el ciudadano · 200+ eventos de vida",
    "simp.bullet2": "Multi-tenant para ministerios y agencias",
    "simp.bullet3": "Identidad biométrica y criptográfica",
    "simp.bullet4": "On-premise, híbrida o nube soberana",
    "simp.bullet5": "API abiertas · interoperables con sistemas heredados",
    "simp.bullet6": "Trazabilidad completa y transparencia de grado electoral",
    "simp.cta": "Solicitar demo de SIMP",

    "section.industries.tag": "03 · Sectores",
    "section.industries.title": "Los sectores que impulsamos.",
    "ind.public": "Sector público y gobierno",
    "ind.elections": "Comisiones electorales",
    "ind.telecom": "Telecomunicaciones",
    "ind.banking": "Banca y seguros",
    "ind.mining": "Minería y recursos naturales",
    "ind.health": "Sistemas de salud",
    "ind.media": "Medios y entretenimiento",
    "ind.utilities": "Servicios públicos y gobiernos regionales",

    "section.projects.tag": "04 · Trayectoria",
    "section.projects.title": "Más de 30 años. Una huella continental.",
    "section.projects.sub": "Programas electorales, de identidad y empresariales entregados en África.",
    "projects.elections_label": "Programas electorales",
    "projects.docs_label": "Documentos de identidad emitidos",
    "projects.partners_label": "Socios tecnológicos",
    "projects.offices_label": "Oficinas",

    "section.partners.tag": "05 · Socios",
    "section.partners.title": "Construido con las plataformas líderes del mundo.",

    "section.values.tag": "06 · Valores",
    "section.values.title": "Por qué los clientes eligen Bigradap.",
    "val.quality.title": "Calidad",
    "val.quality.desc": "Procesos de grado ISO. Cada entregable es diseñado, revisado y probado.",
    "val.transparency.title": "Transparencia",
    "val.transparency.desc": "Arquitecturas auditables. Documentación abierta. Responsabilidad clara.",
    "val.reliability.title": "Fiabilidad",
    "val.reliability.desc": "Sistemas que resisten elecciones, auditorías y cargas críticas 24/7.",
    "val.speed.title": "Velocidad",
    "val.speed.desc": "Equipos continentales preparados para despliegues rápidos y seguros.",
    "val.security.title": "Seguridad",
    "val.security.desc": "Criptografía, biometría, segregación de funciones, soberanía por defecto.",
    "val.collaboration.title": "Colaboración",
    "val.collaboration.desc": "Trabajamos codo a codo con ministerios, reguladores y operadores.",

    "cta.footer.title": "Construyamos el próximo sistema a escala nacional.",
    "cta.footer.sub": "Desde la primera llamada de alcance hasta la operación a largo plazo — nuestros equipos están listos.",
    "cta.footer.btn": "Iniciar conversación",

    "about.tag": "Quiénes somos",
    "about.title": "Tres décadas de soluciones TI inteligentes.",
    "about.p1": "Bigradap Group Technologies (PTY) LTD es un proveedor de soluciones TIC con oficinas en Sudáfrica y la República Democrática del Congo, y entregas activas en todo el continente africano.",
    "about.p2": "Diseñamos, desarrollamos, suministramos, implementamos y mantenemos Sistemas Integrados Multisectoriales Permanentes para clientes del sector público y privado.",
    "about.p3": "Nuestra misión: aplicar el enfoque Intelligence Logic a cada reto del cliente — soluciones TI a medida que garantizan calidad, transparencia, fiabilidad, velocidad y seguridad.",
    "about.mission.label": "Misión",
    "about.mission.body": "Aplicamos el enfoque Intelligence Logic en nuestras soluciones TI a medida para garantizar calidad, transparencia, fiabilidad, velocidad y seguridad.",
    "about.vision.label": "Visión",
    "about.vision.body": "Usar la última tecnología para convertirnos en un proveedor líder mundial de servicios TI — al servicio del continente africano y del mundo.",

    "services.tag": "Servicios",
    "services.title": "Capacidades de extremo a extremo.",
    "services.sub": "De la viabilidad a la operación 24/7 — un solo equipo responsable.",

    "simp.tag": "Insignia",
    "simp.hero_title": "SIMP — Sistema Integrado Multisectorial Permanente.",
    "simp.hero_sub": "Una columna vertebral de datos soberana para población, identidad y eventos de vida.",
    "simp.section1.title": "Qué hace SIMP",
    "simp.section1.body": "SIMP unifica registros entre ministerios — civil, identidad, elecciones, salud, educación, fiscalidad y migración — en una única plataforma auditable. Cada evento de vida se captura una vez y se comparte con procedencia criptográfica.",
    "simp.section2.title": "Cómo está construido",
    "simp.section2.body": "Microservicios modulares sobre un núcleo endurecido. Captura biométrica, personalización segura de documentos, estaciones de campo offline, APIs abiertas y modelo de despliegue soberano — on-prem, híbrido o nube nacional.",

    "industries.tag": "Sectores",
    "industries.title": "Los sectores a los que servimos.",
    "industries.sub": "Cada programa está liderado por especialistas que hablan el idioma del regulador.",

    "projects.tag": "Trayectoria",
    "projects.title": "Programas seleccionados.",
    "projects.sub": "Programas electorales, de identidad y empresariales entregados en África y más allá.",
    "projects.elections_title": "Huella electoral",
    "projects.docs_title": "Identidad y documentos seguros",
    "projects.enterprise_title": "Clientes empresariales",

    "contact.tag": "Contacto",
    "contact.title": "Hable con nuestros equipos.",
    "contact.sub": "Cuéntenos su programa. Respondemos en un día hábil.",
    "contact.form.name": "Nombre completo",
    "contact.form.email": "Email profesional",
    "contact.form.company": "Organización",
    "contact.form.country": "País",
    "contact.form.phone": "Teléfono (opcional)",
    "contact.form.subject": "Asunto",
    "contact.form.message": "Cuéntenos sobre su proyecto",
    "contact.form.submit": "Enviar mensaje",
    "contact.form.sending": "Enviando…",
    "contact.form.success": "Gracias — nuestro equipo le responderá en breve.",
    "contact.form.error": "Algo salió mal. Inténtelo de nuevo.",
    "contact.offices_title": "Oficinas",
    "contact.email_title": "Email",
    "contact.phone_title": "Teléfono",

    "footer.rights": "Todos los derechos reservados.",
    "footer.tagline": "Focused, Reliable and Intelligent Business Solutions.",
    "footer.legal": "Legal",
    "footer.privacy": "Privacidad",
    "footer.terms": "Términos",
  },
};

// Merge extras (founder, careers, legal, clients, cookieBanner) into each locale
Object.keys(t).forEach((locale) => {
  Object.values(extras).forEach((group) => {
    Object.assign(t[locale], group[locale] || group.en || {});
  });
});

export default t;
